import { render, staticRenderFns } from "./payment-succes.vue?vue&type=template&id=5b1dce35&scoped=true&"
import script from "./payment-succes.vue?vue&type=script&lang=js&"
export * from "./payment-succes.vue?vue&type=script&lang=js&"
import style0 from "./payment-succes.vue?vue&type=style&index=0&id=5b1dce35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1dce35",
  null
  
)

export default component.exports